import PatientLanding from './home';

export default PatientLanding;
